import { useState } from 'react';

import { telegramVibrate } from '@app/shared/utils/common';
import { FeedPandaModalState, FeedPandaType } from '@app/shared/types/pages/home';
import { TWELVE_HOURS_MS } from '@app/shared/constants/common';
import { useLiveCountdown } from '@app/shared/hooks/useLiveCountdown';

const INITIAL_FEED_PANDA_MODAL_STATE: FeedPandaModalState = { isOpen: false };

export const useFeedPandaModal = (lastPandaFedAt?: number | null) => {
  const [modalState, setModalState] = useState(INITIAL_FEED_PANDA_MODAL_STATE);
  const { isExpired, formattedLeft } = useLiveCountdown(lastPandaFedAt ?? 0, TWELVE_HOURS_MS);

  const openModal = (type: FeedPandaType) => {
    setModalState({ isOpen: true, type });
  };

  const closeModal = () => {
    telegramVibrate();
    setModalState(INITIAL_FEED_PANDA_MODAL_STATE);
  };

  const handleFeedPandaClick = () => {
    if (!isExpired) {
      openModal(FeedPandaType.FEED_SUCCESS);
      return;
    }
    openModal(FeedPandaType.FEED);
  };

  const handleFeedPandaSuccess = () => {
    // nop
  };

  return {
    modalState,
    openModal,
    closeModal,
    handleFeedPandaClick,
    handleFeedPandaSuccess,

    isFeedModalOpen: modalState.isOpen && modalState.type === FeedPandaType.FEED,
    isFeedSuccessModalOpen: modalState.isOpen && modalState.type === FeedPandaType.FEED_SUCCESS,

    isExpired,
    formattedLeft,
  };
};
